import React, { useState, useEffect } from 'react';
import ProjectsCard from '../../Components/Projects/ProjectsCard';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import config from '../../config';

const ProjectsList = () => {

	const [projects, setProjects] = useState([]);

	  useEffect(() => {
	    fetch(`${config.apiUrl}/projects`) 
	      .then(response => response.json())
	      .then(data => setProjects(data))
	      .catch(error => console.error('Error fetching projects', error));
	  }, []);

	return (
		<div className='box-shadow'>
			<SectionHeader name={'Projects'} />
			<div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
				{projects.map((project) => {
					return (			
						<ProjectsCard  
							key={project.id}
							photo={`${project.photo}-small.png`} 
							title={project.title}
							url={project.url}
							year={project.year}
							body={project.body}
							git={project.git_repo}
							tech={project.technologies} />
						)
					})	
				}
			</div>
		</div>
	)
}

export default ProjectsList;